import { Component, OnInit } from '@angular/core';
import {SafePipe} from '../safe.pipe'

@Component({
  selector: 'app-imoveis',
  templateUrl: './imoveis.component.html',
  styleUrls: ['./imoveis.component.css']
})
export class ImoveisComponent implements OnInit {
  videos:string[] = ['https://www.youtube.com/embed/ISQ_a-wiFR0', 'https://www.youtube.com/embed/aQdVOtHizlc', 'https://www.youtube.com/embed/q3NJCsIrzfg']
  videoSelected:string
  constructor() { }

  ngOnInit() {
  	this.videoSelected = this.videos[0];
  }
  onThumbClick(index:number){
  	this.videoSelected = this.videos[index];
  }
}



// WEBPACK FOOTER //
// ./src/app/imoveis/imoveis.component.ts